import React from 'react'

import EditorService from 'live/services/editor'
import i18n from 'live/services/i18n'
import Registry from 'live/services/registry'
import ServiceLocator from 'live/services/service-locator'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { addWidgetEditorToMenu } from 'plugin-assets/shared/widget/lib/util'

import { ImageLogColorScale } from 'live-charts/types/image-log'

import { withSuspenseWrapper } from '../../components/SuspenseWrapper'
import Editor from '../../components/editor/image-log'
import DashboardActions from '../../components/editor/image-log/dashboard-actions'
import LinkServiceProviderTab, { saveData } from '../../components/image-log/LinkServiceProviderTab'
import { ImageLogConfig, ImageLogEvent, ImageLogState } from '../../types/image-log'
import { imageLogReducer } from './reducer'

const widgetType = 'image-log'
export const VERTICAL_ENABLED = true // TODO: vertical/horizontal config

const ImageLogWidget = reactWidgetWrapper<ImageLogState, FlowMessage<ImageLogEvent>, DefaultChartConfigs>(
    withSuspenseWrapper(React.lazy(() => import('./ImageLogWidgetController'))),
    imageLogReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: {
                    ...configs.widget,
                    jsonConfig: {
                        ...configs.widget.jsonConfig,
                        verticalEnabled: VERTICAL_ENABLED
                    }
                }
            }
        }
    }
)

const DEFAULT_CHART_CONFIG: LiveWidgetConfig<ImageLogConfig> = {
    verticalEnabled: VERTICAL_ENABLED,
    interpolate: true,
    numberOfVisibleAxes: 2,
    colorScale: ImageLogColorScale.YellowOrangeBrown,
    hideYAxisValues: false,
    hideXAxis: false,
    useDefaultMinMax: true,
    scaleMin: undefined,
    scaleMax: undefined,
    imageType: undefined,
    kind: widgetType,
    span: 'ts 0 to ts 16000',
    spanPicker: {
        type: 'depth',
        configs: {
            depth: {}
        }
    }
}

const EditorInfo = {
    order: -5,
    type: 'image-log-editor',
    label: i18n('ImageLog standard'),
    description: i18n('Imagelog chart editor'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: Editor,
    defaultWidgetType: widgetType
})

addWidgetEditorToMenu({
    ...EditorInfo,
    thumbnail: require('../../../assets/img/imagelog.png').default,
    tags: ['assets', 'imagelog']
})
widgetService.register({
    type: widgetType,
    get name() {
        return 'ImageLog'
    },
    config: DEFAULT_CHART_CONFIG,
    policies: {
        handleOwnMissingData: true
    },
    description: i18n('ImageLog chart'),
    ui: { editor: EditorInfo.type },
    impl: ImageLogWidget,
    queryHandlerKind: widgetType
})
widgetService.editor(widgetType, EditorInfo.type)
widgetService.dashboardActions(widgetType, 'view', DashboardActions)

type ExtraTab = {
    component?: React.FC<{
        interventionId: string
        sectionId: string
        runId: string
        state: Record<string, unknown>
        onChange: (field: string, value: unknown) => void
    }>
    id?: string
    label?: string
    runType: 'drilling' | 'casing' | 'non_tubular'
    initialState?: Record<string, unknown>
    save?: (interventionId: string, section: { id: string }, runId: string, state: Record<string, unknown>) => void
}

type RunTabs = {
    RunTabsRegistry: Registry<ExtraTab>
}

ServiceLocator.getService('intervention-drilling-sections-runs-tabs').then((s: RunTabs) => {
    s.RunTabsRegistry.register({
        component: LinkServiceProviderTab,
        id: 'image-log',
        label: 'Imagelog',
        runType: 'drilling',
        initialState: { serviceProvider: null },
        save: saveData
    })
})
